import { useParams } from "react-router-dom";
import useSWR from "swr";
import { CustomizeCover_Api } from "../../../../api/endpoints";
import { fetcher } from "../../../../services/fetcher";
import {
  explorePlansApi,
  parseComparisonsListResponse,
} from "../../services/explorePlansApi";
import SharedPlanDetail from "../SharedPlanDetail/SharedPlanDetail";

const DetailCustomizePlan = () => {
  const { id } = useParams();

  const {
    data: explorerDataById,
    error: explorerDataByIdError,
    isLoading: isExplorerDataByIdLoading,
  } = useSWR(explorePlansApi.detail(id), fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const apiUrl = `${CustomizeCover_Api}${id}/detail/`;
  const { data, error, isLoading } = useSWR(apiUrl, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const explorerProfileId =
    (explorerDataById && id) ||
    data?.explorer_profile_id ||
    data?.explorer_profile ||
    data?.explore_profile_id ||
    data?.explore_profile;

  const {
    data: explorerSourceData,
    error: explorerSourceError,
    isLoading: isExplorerSourceLoading,
  } = useSWR(
    explorerProfileId ? explorePlansApi.detail(explorerProfileId) : null,
    fetcher,
    { revalidateOnFocus: false }
  );
  const {
    data: itineraryDays,
    error: itineraryError,
    isLoading: itineraryLoading,
  } = useSWR(
    explorerProfileId ? explorePlansApi.itineraryList(explorerProfileId) : null,
    fetcher,
    { revalidateOnFocus: false }
  );
  const {
    data: comparisonRowsRaw,
    error: comparisonsError,
    isLoading: comparisonsLoading,
  } = useSWR(
    explorerProfileId ? explorePlansApi.comparisonsList(explorerProfileId) : null,
    fetcher,
    { revalidateOnFocus: false }
  );

  const sourceData = explorerDataById || explorerSourceData || data;
  const viewData = sourceData
    ? {
        ...sourceData,
        itinerary_days:
          Array.isArray(itineraryDays) && itineraryDays.length > 0
            ? itineraryDays
            : sourceData?.itinerary_days,
        comparison_rows:
          explorerProfileId && comparisonRowsRaw
            ? parseComparisonsListResponse(comparisonRowsRaw)
            : sourceData?.comparison_rows,
      }
    : sourceData;

  return (
    <SharedPlanDetail
      data={viewData}
      isLoading={
        (isExplorerDataByIdLoading && isLoading) ||
        (!!explorerProfileId &&
          (isExplorerSourceLoading || itineraryLoading || comparisonsLoading))
      }
      error={
        !viewData
          ? error ||
            explorerDataByIdError ||
            explorerSourceError ||
            itineraryError ||
            comparisonsError
          : null
      }
      showBackButton
      errorMessage="Failed to load plan details"
    />
  );
};

export default DetailCustomizePlan;